let globalPopupNotification;

export class LocalNotification {
    constructor(headline, body, hideAfter = 10000, force = true) {
        this.headline = headline;
        this.body = body;
        this.isLocal = true;
        this.force = force;
        this.hideAfter = hideAfter;
    }
}


export function registerPopupComponent(popupNotification) {
    globalPopupNotification = popupNotification;
}

/**
 * @param {LocalNotification} notificationData
 */
export function showLocalNotification(notificationData) {
    if (!globalPopupNotification) {
        return;
    }
    globalPopupNotification.showLocalNotification(notificationData);
}

export function localNotification(headline, body, hideAfter = 10000, force = true) {
    if (!globalPopupNotification) {
        return;
    }
    globalPopupNotification.showLocalNotification(new LocalNotification(headline, body, hideAfter, force));
}